<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm" :params="{operationId: operationId, dossierOperationCreationDone: this.$route.params.dossierOperationCreationDone}" :title="$t('Operation.Dossier')" route-back="OperationShowDossier"/>
      </div>
      <div class="page-subtitle mt-2">{{ $t('operation.dossier.subtitle') }}</div>

      <steps-menu
        :current-step="currentStep"
        :last-active-step="lastActiveStep"
        :tab-menu="tabMenu"
        @stepChanged="stepChanged"/>

      <DossierOperationInformations
        v-if="currentStep === 0"
        ref="informations"
        :dossierId="parseInt(dossierId)"
        @didChangeValue="didChangeValue"
        @didContinue="didContinue"/>

      <DossierOperationSituation
        v-if="currentStep === 1"
        ref="situations"
        :dossierId="parseInt(dossierId)"
        :situationCreationDone="situationCreationDone"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinueSituation="didContinueSituation"/>


      <DossierOperationInvestissementStep
        v-if="currentStep === 2"
        ref="investissementStep"
        :dossierId="parseInt(dossierId)"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinueInvestissement="didContinueInvestissement"/>


      <DossierOperationFinancialStep
        v-if="currentStep === 3"
        ref="financialStep"
        :operation-bilan-id="parseInt(operationBilanId)"
        :operationId="parseInt(operationId)"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinueFinancial="didContinueFinancial"/>

      <DossierOperationDemandeFinancement
        v-if="currentStep === 4"
        ref="demandeFinancement"
        :dossierId="parseInt(dossierId)"
        :fundingRequestCreationDone="fundingRequestCreationDone"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinueDemande="didContinueDemande"/>

    </b-container>
  </div>

</template>

<script>

import StepsMenu from "../../components/b122/stepsMenu";
import i18n from '../../i18n'
import BackArrow from '../../components/b122/BackArrow'
import DossierOperationCadastre from './dossierOperationCreateSteps/DossierOperationCadastre'
import DossierOperationDemandeFinancement from './dossierOperationCreateSteps/DossierOperationDemandeFinancement'
import DossierOperationEDM from './dossierOperationCreateSteps/DossierOperationEDM'
import DossierOperationInformations from './dossierOperationCreateSteps/DossierOperationInformations'
import DossierOperationSituation from './dossierOperationCreateSteps/DossierOperationSituation'
import DossierOperationPlans from './dossierOperationCreateSteps/DossierOperationInvestissement'
import DossierOperationInvestissementStep from './dossierOperationCreateSteps/DossierOperationInvestissementStep'
import DossierOperationFinancialStep from './dossierOperationCreateSteps/DossierOperationFinancialStep'


import api from "../../services/api";
import DossierOperationInvestissement from "./dossierOperationCreateSteps/DossierOperationInvestissement";

export default {

  name: "OperationDossierCreateEdit",

  components: {
    DossierOperationInvestissement,
    DossierOperationSituation,
    StepsMenu,
    i18n,
    BackArrow,
    DossierOperationCadastre,
    DossierOperationDemandeFinancement,
    DossierOperationEDM,
    DossierOperationInformations,
    DossierOperationPlans,
    DossierOperationInvestissementStep,
    DossierOperationFinancialStep
  },

  data() {
    let d = this.$route.params.dossier
    return {
      currentStep: 0,
      dossier:d,
      dossierId: d && d.id ? d.id : null,
      operationId: this.$route.params.operationId,
      investmentCreationDone: false,
      fundingRequestCreationDone: false,
      financialCreationDone: false,
      situationCreationDone: false,
      askConfirm: false,
      operationBilanId: null,
    }
  },

  computed: {
    tabMenu() {
      return [
        i18n.t('operation.dossier.menu1'),
        i18n.t('operation.dossier.menu2'),
        i18n.t('operation.dossier.menu3'),
        i18n.t('operation.dossier.menu4'),
        i18n.t('operation.dossier.menu5'),
      ]
    },
    lastActiveStep() {
      if (this.fundingRequestCreationDone) {
        return 4
      } else if (this.financialCreationDone) {
        return 3
      } else if (this.investmentCreationDone) {
        return 2
      } else if (this.situationCreationDone) {
        return 1
      } else {
        return 0
      }
    },
  },

  async mounted() {
    this.operationId = this.$route.params.operationId
    await this.fetchOperation()
    await this.fetchData()
  },

  methods: {

    async fetchData() {
      if (this.dossierId) {
        await this.fetchDossier()
      }
    },

    async fetchDossier() {
      await api
        .get(`/dossierOperation/${this.dossierId}`)
        .then(response => {
          this.investmentCreationDone = response.data.investmentCreationDone
          this.fundingRequestCreationDone = response.data.fundingRequestCreationDone
          this.financialCreationDone = response.data.financialCreationDone
          this.situationCreationDone = response.data.situationCreationDone
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operationBilanId = response.data.bilanId
          if(!this.dossierId) {
            this.dossierId = response.data.dossierOperationId
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            console.error(error.response.data.message)
          }
        })
    },

    stepChanged(index) {
      this.currentStep = index
    },

    didChangeValue() {
      this.askConfirm = true
    },

    didBack() {
      this.currentStep--
    },

    incrementStep() {
      this.currentStep++
    },

    async didContinue(dossierId) {
      this.dossierId = dossierId
      this.incrementStep()
    },

    async didContinueSituation() {
      this.situationCreationDone = true
      this.incrementStep()
    },

    async didContinueInvestissement() {
      this.investmentCreationDone = true
      this.incrementStep()
    },

    async didContinueFinancial() {
      this.financialCreationDone = true
      this.incrementStep()
    },

    async didContinueDemande() {
      this.fundingRequestCreationDone = true;
      await this.$router.push({
        name: 'OperationShowDossier',
        params: {
          operationId: this.operationId,
          dossierOperationCreationDone: true
        }
      });
    }


  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationDossier/OperationDossierCreateEdit.vue